import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <app-build-ribbon></app-build-ribbon>
    <router-outlet></router-outlet>
  `,
})
export class AppComponent {}
